import type { AddonSelection, CartItem } from "@/components/cart/CartContext";

/**
 * How a cart line is identified. Pure and deterministic, so it is split out of
 * `CartContext.tsx`: a non-component export beside a component defeats fast
 * refresh for the whole module (react-refresh/only-export-components), and the
 * provider is the part worth hot-swapping.
 */

/** Stable signature for a set of selected add-ons. */
function addonsSig(addons?: AddonSelection[]): string {
	if (!addons || addons.length === 0) return "";
	return addons
		.map((a) => `${a.gi}.${a.ci}`)
		.sort()
		.join(",");
}

/** A cart line is identified by product + variant + add-on selection + note. */
export function cartKey(
	productId: string,
	variantId?: string,
	addons?: AddonSelection[],
	note?: string,
): string {
	const base = variantId ? `${productId}:${variantId}` : productId;
	const sig = addonsSig(addons);
	let key = sig ? `${base}#${sig}` : base;
	if (note && note.trim()) key += `@${note.trim()}`;
	return key;
}

/** Key for an existing cart line. */
export function lineKey(item: CartItem): string {
	return cartKey(item.productId, item.variantId, item.addons, item.note);
}
